import { useNavigatorSearchContext } from "@dashboard/components/NavigatorSearch/useNavigatorSearchContext";
import { Box, Text } from "@saleor/macaw-ui-next";
import { Search } from "lucide-react";
import { useState } from "react";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
  placeholder: {
    id: "appHeaderSearchPlaceholder",
    defaultMessage: "Search or type a command",
    description: "app header command search box placeholder",
  },
});

// Detect Mac to show the correct modifier hint (⌘K vs Ctrl K).
const isMac =
  typeof navigator !== "undefined" && /Mac|iPod|iPhone|iPad/.test(navigator.platform);

/**
 * Command-search box in the global header. It is not a real input — clicking it
 * (or ⌘K / Ctrl+K) opens the NavigatorSearch command palette, which owns the
 * actual query state.
 */
export const AppHeaderSearch = () => {
  const intl = useIntl();
  const { setNavigatorVisibility } = useNavigatorSearchContext();
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      as="button"
      type="button"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={3}
      width="100%"
      __maxWidth="420px"
      paddingX={3}
      paddingY={2}
      borderRadius={3}
      borderWidth={1}
      borderStyle="solid"
      cursor="pointer"
      data-test-id="app-header-search"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={() => setNavigatorVisibility(true)}
      style={{
        backgroundColor: hovered ? "#FFFFFF" : "#F5F6F8",
        borderColor: hovered ? "#C7CBD4" : "#E5E7EB",
        transition: "background-color 0.15s ease, border-color 0.15s ease",
      }}
    >
      <Box display="flex" alignItems="center" gap={2} style={{ color: "#6B7280" }}>
        <Search size={16} strokeWidth={2} />
        <Text size={3} style={{ color: "#6B7280" }}>
          {intl.formatMessage(messages.placeholder)}
        </Text>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        paddingX={1.5}
        borderRadius={2}
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          color: "#6B7280",
        }}
      >
        <Text size={1} fontWeight="medium" style={{ color: "#6B7280" }}>
          {isMac ? "⌘K" : "Ctrl K"}
        </Text>
      </Box>
    </Box>
  );
};
